import React from "react";

import { CurserDataType, LayoutType } from "../types";

import Gradient from "./Gradient";
import SvgLayout, { SvgLayoutProps } from "./SvgLayout";
import Timeseek from "./timeseek";

type HttpLayoutProps = {
  cursorData?: CurserDataType;
} & LayoutType &
  SvgLayoutProps;

const HttpLayout = (props: HttpLayoutProps) => {
  const {
    chartId,
    children,
    showBrush,
    positions,
    yScale,
    xScale,
    tick,
    onMouseMove,
    onMouseLeave,
    cursorData,
    resourceName
  } = props;

  return (
    <SvgLayout
      onMouseLeave={onMouseLeave}
      onMouseMove={onMouseMove}
      xScale={xScale}
      yScale={yScale}
      chartId={chartId}
      positions={positions}
      tick={tick}
      resourceName={resourceName}
      showBrush={showBrush}
    >
      {children}
      <Gradient positions={positions} id={chartId} />
      <Timeseek yScale={yScale} cursorData={cursorData} />
    </SvgLayout>
  );
};
export default HttpLayout;
